<template>
  <div :class="{ 'FormSelect--fill': fill }" class="FormSelect">
    <i class="fa fa-angle-down" />
    <select :value="currentValue" @input="handleInput">
      <slot />
    </select>
  </div>
</template>

<script>
import './style.scss'
import VueTypes from 'vue-types'

export default {
  name: 'FormSelect',
  props: {
    // Vue 3 v-model prop
    modelValue: VueTypes.any,
    // Vue 2 v-model prop (for compatibility mode)
    value: VueTypes.any,
    fill: { type: Boolean, required: false, defaultValue: false },
  },
  emits: ['update:modelValue', 'input'],
  computed: {
    currentValue() {
      // Support both Vue 2 and Vue 3 v-model
      return this.modelValue !== undefined ? this.modelValue : this.value
    },
  },
  methods: {
    handleInput(event) {
      const newValue = event.target.value
      // Emit both Vue 2 and Vue 3 events for compatibility
      this.$emit('input', newValue)
      this.$emit('update:modelValue', newValue)
    },
  },
}
</script>
